import { AudioConversationMessage } from 'v2/core/entities/feedback/content';

export const getCurrentPlayingMessageIndex = (
  conversation: AudioConversationMessage[],
  seek: number,
) => {
  const conversationInRange = conversation.filter(
    (conversationUnit) => seek >= conversationUnit.metadata.startTime,
  );

  const lastMsgFromConversationInRange =
    conversationInRange[conversationInRange.length - 1];

  const currentPlayingMsgIndex = conversationInRange.findIndex(
    (conversationUnit) =>
      lastMsgFromConversationInRange.metadata.startTime ===
        conversationUnit.metadata.startTime &&
      lastMsgFromConversationInRange.metadata.endTime ===
        conversationUnit.metadata.endTime,
  );

  return currentPlayingMsgIndex !== -1 ? currentPlayingMsgIndex : 0;
};
